import moment from 'moment'
import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, InputGroup, InputGroupAddon, 
        Label, Col, Table, Form, FormGroup } from 'reactstrap';
import 'react-select/dist/react-select.css';
import Select from 'react-select'
import { userRef } from '../../config'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'

export default class AdminPanel extends Component {
  
  constructor(props) {
    super(props)
    this.editUser = this.editUser.bind(this)
    this.onRemoveUser = this.onRemoveUser.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.buildOptions = this.buildOptions.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleUserTypeChange = this.handleUserTypeChange.bind(this)
    this.state = {
      loading:true,
      users: null,
      selectedUser: null,
      showModal: false,
      verifyModal:false,
      checkbox: [],
      requests:[],
      userId:"",
      userEmail:"",
      codeBankModal:false,
      userCodebanks:[],
      userType: localStorage.getItem('userType'),
      value:[]
    }
  }

  toggleModal() {
    this.setState({
      showModal: !this.state.showModal
    })
  }

  editUser(uid) {
    let user = this.state.users.filter(user => user.uid === uid)[0]
    this.setState({
      isEditing: true,
      userBeingEdited: user,
      value: Object.keys(user.allowableRoutes).map(k => ({label:k, value: k})),
      showModal:true,
      userType: user.userType
    })
  }

  onSubmitUserChanges(e) {
    e.preventDefault();
    if(!this.state.userBeingEdited) {
      this.setState({
        error: 'Tried to submit changes for a invalid user'
      })
    }
    userRef.child(this.state.userBeingEdited.uid).update(this.state.userChanges, () => {
      this.setState({
        message: 'user updated successfully'
      })
    })
  }

  buildOptions() {
    let EnabledRoutes = Object.keys(this.state.userBeingEdited.allowableRoutes).map(k => ({label:k, value:k}))
  }

  onRemoveUser(uid) {
    userRef.child(uid).remove(() => {
      this.setState({
        message: 'user removed successfully',
        users: this.state.users.filter(user => user.uid !== uid)
      })
    })
  }

  fetchUsers() {
    userRef.once('value', s => {
      let users = [];
      let codebank = []
      if(s.exists()) {
        s.forEach(snap => {
          // if(snap.hasChild("LinkedUsers") || snap.hasChild("codebank")){
          //   codebank.push(snap.val())
          //   return
          // }
          users.push(Object.assign({}, snap.val()))
        })
        // console.log(users)
      // let users = Object.keys(s.val()).map(k => {
      //   if(s.val()[k].hasChild("LinkedUsers") || s.val()[k].hasChild("codebank")){
      //     alert(JSON.stringify(s.val()[k]))
      //   }
        // if(k === "ob") {
        //   alert(JSON.stringify(s.val()[k]))
        // }
      // })
        this.setState({
          users,
          loading: false
        })
      }
    })    
    // debugger
    // userRef.once('value', s => {
    //   console.log(s.val())
    //   if(s.exists()) {
    //     let users = Object.keys(s.val()).map(k => s.val()[k])
    //     this.setState({
    //       users,
    //       loading: false
    //     })
    //   }
    // })
  }

  handleSelectChange(value) {
    let allowableRoutesForUser = {}
      value.split(',').forEach(route => {
        allowableRoutesForUser[route] = true
    })
    userRef
    .child(this.state.userBeingEdited.uid)
    .child('allowableRoutes')
    .set(allowableRoutesForUser)
    .then(() => {
      this.setState({
        value
      })
    })
  }

  handleUserTypeChange(userType) {
    console.log('user type changed', userType)
    userRef
    .child(this.state.userBeingEdited.uid)
    .child('userType')
    .set(userType)
    .then(() => {
      this.setState({
        userType
      })
    })
  }

  checkbox = (e, counter) => {
    let isChecked = e.target.checked
    let emailList = []
    if(isChecked){
      let email = e.target.value;
      let index = this.state.checkbox.indexOf(email)
      if(index === -1){
        this.state.checkbox.push(email)
      }
    }
    this.setState({checkbox: this.state.checkbox})
  }

  toggleCodebank = () => {
    this.setState({
      codeBankModal: !this.state.codeBankModal
    });
  }

  toggle = () => {
    if(this.state.requests.length < 1){
      Alert.error('No record to verify', {
          position: 'top-right',
          effect: 'scale',
          timeout: 5000,
          offset:'0'
      });
      return
    }
    this.setState({
      verifyModal: !this.state.verifyModal
    });
  }

  verifyEmail = () => {
    this.state.checkbox.map(item => {
      // if(userRef.child(this.state.userId).hasChild("LinkedUsers")){
        userRef.child(this.state.userId).child("LinkedUsers").orderByChild("email").equalTo(item)
        .once('value', snap => {
          snap.forEach(snapshot => {
            if(snapshot.val().status === "pending"){
              snapshot.ref.update({
                status:"approved"
              })
            }
          })
        }).then(() => {
          this.setState({
            verifyModal: !this.state.verifyModal,
            checkbox: []
          });
        })
      // }
    })
  }

  rejectRequest = () => {
    this.state.checkbox.map(item => {
      // if(userRef.child(this.state.userId).hasChild("LinkedUsers")){
        userRef.child(this.state.userId).child("LinkedUsers").orderByChild("email").equalTo(item)
        .once('value', snap => {
          snap.forEach(snapshot => {
            if(snapshot.val().status === "pending"){
              snapshot.ref.update({
                status:"rejected"
              })
            }
          })
        }).then(() => {
          this.setState({
            verifyModal: !this.state.verifyModal,
            checkbox: []
          });
        })
      // }
    })
  }

  fetchCodeBank = email => {
    userRef.once("value", snapshot => {
      snapshot.forEach(snap => {
        if(typeof snap.val().codebank != "undefined"){
          userRef.child(snap.key).once("value", s => {
            if(s.val().email === email){
              this.setState({
                userCodebanks:Object.assign({}, s.val().codebank),
                codeBankModal:!this.state.codeBankModal
              })
            }
          })
        }
      })
    })
  }

  getUserInfo = () => {
    let query
    let userItems = []
    userRef.once("value", snapshot => {
      snapshot.forEach(snap => {
        if(typeof snap.val().LinkedUsers != "undefined"){
          this.setState({userId:snap.key})
          console.log(snap.val())
          query = userRef.child(snap.key).child("LinkedUsers").orderByChild("status").equalTo("pending")
          query.once('value', s => {
            if(s.exists()){
              Object.keys(s.val()).map(k => {
                userItems.push(Object.assign({}, s.val()[k], {requestTo:snap.val().email}))
              })
            }
          }).then(() => {
            this.setState({
              requests:userItems
            });
          })
        }
      })
    })

    userRef.on("child_changed", snapshot => {
      this.setState({userId:snapshot.key})
      let query = userRef.child(snapshot.key).child("LinkedUsers").orderByChild("status").equalTo("pending")
      query.once('value', snap => {
        userItems = []
        snap.forEach(s => {
          if(s.exists()){
            userItems.push(Object.assign({}, s.val(), {requestTo:s.val().email} ))
          }
        })
        this.setState({
          requests:userItems
        });
      })
    })
  }

  componentDidMount() {
    this.fetchUsers()
    this.getUserInfo()
  }

  render() {
    const options = [
      { label: 'Reports', value: 'reports' },
      { label: 'OnSaleList', value: 'onsalelist' },
      { label: 'Calculator', value: 'calculator' },
      { label: 'CodeBank', value: 'codebank' },
      { label: 'Research', value: 'research' }
    ];

    let tableHeaders
    let counter = 1
    let buildCodebankModalBody = Object.keys(this.state.userCodebanks).map(index => {
        console.log(this.state.userCodebanks[index])
        return (
          <tr>
            <td>{this.state.userCodebanks[index].eventName}</td>
            <td>{this.state.userCodebanks[index].expirationDate}</td>
            <td>{this.state.userCodebanks[index].password}</td>
          </tr>
        )
    })

    let buildModalBody = this.state.requests.map(item => {
        return (
          <tr>
            <td className='break-all'>{item.email}</td>
            <td className='break-all'>{item.requestTo}</td>
            <td className='text-right'>
              <FormGroup>
                <Input type="checkbox" id="checkbox1" value={item.email} onChange={(e, counter) => this.checkbox(e, counter)}/>{' '}
              </FormGroup>
            </td>
          </tr>
        )
        counter++
      })

    if(this.state.loading) {
      return (
        <div className='animated fadeIn'>
          <h4 className='text-center'> Fetching users </h4>
        </div>
      )
    }
    tableHeaders = Object.keys(this.state.users[0])
    tableHeaders.push("codebank")
    let tableHeaderNodes = tableHeaders.map((text, index) => {
      if(text !== 'allowableRoutes') {
        return (
          <th> {text} </th>
        )
      }
    })
    let tableRows = this.state.users.map((user, index) => {
      let tableCellsForRow = Object.keys(user).map((k, index) => {
        if(k === 'createdAt') {
          return (
            <td key={index}> {moment(user[k]).format('dddd, MMMM Do YYYY,')} </td>
          )
        // }else if(k !== 'allowableRoutes' && k !== 'pendingApproval') {
        }else if(k !== 'allowableRoutes') {
          if(k == "codebank" || k == "LinkedUsers"){}
          else{
            return (
              <td key={index}> {user[k]} </td>
            )            
          }
        }else if(k !== 'pendingApproval'){
            <td key={index}></td>
        }
      })
      return (
        <tr key={index}>
          {tableCellsForRow}
          <td> <button onClick={() => this.fetchCodeBank(user.email)} className='btn btn-info btn-sm'><i className='fa fa-x'/> View Code</button> </td>
          <td> <button onClick={() => this.onRemoveUser(user.uid)} className='btn btn-danger btn-sm'><i className='fa fa-x'/> Delete User</button> </td>
          <td> <button onClick={() => this.editUser(user.uid)} className='btn btn-warning btn-sm'><i className='fa fa-x'/> Edit User</button> </td>
        </tr>
      )
    })
    return (
      <div>
      <div className='animated fadeIn'>
      <div className='form-group'>
        <div className='row '>
          <div className="col-md-10 "><h4 className='text-center'> Admin Panel </h4></div>
          <div className="col-md-2 text-right"><Button color="primary"  onClick={this.toggle}>Verify</Button>{' '}</div>
        </div>
      </div>
        <div className='row'>
          <Modal isOpen={this.state.showModal}>
            <ModalHeader toggle={this.toggleModal} className={this.props.className}>
              {this.state.showModal ? `You are editing ${this.state.userBeingEdited.firstName}`: ''}
            </ModalHeader>
            <ModalBody>
                {this.state.showModal ?
                <div className='row'>
                <div className='col-md-6 col-lg-6 col-sm-6'>
                    <div className='card'>
                      <div className='card-header'>
                        <strong> User form </strong>
                      </div>
                    <div className='card-block'>
                      {Object.keys(this.state.userBeingEdited).map(k => {
                        console.log('got key', k)
                        if(k !== 'allowableRoutes' && k !== 'pendingApproval') {
                          if(k === 'userType') {
                            return (
                              <div className='form-group'>
                                <label for='userType'> {k} </label>
                                <Select
                                  label='usertype'
                                  simpleValue={true}
                                  options={[{label:'admin', value:'admin'}, {label:'user', value:'user'}]}
                                  onChange={this.handleUserTypeChange}
                                  value={this.state.userType ? this.state.userType: this.state.userBeingEdited.userType}
                                />
                              </div>
                            )
                          }
                          return (
                            <div className='form-group'>
                              <label for='testing'> {k} </label>
                              <input readOnly className='form-control' value={this.state.userBeingEdited[k]}/>
                            </div>
                          )
                        }
                      })}
                    </div>
                  </div>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-6'>
                  <div className='card'>
                    <div className='card-header'>
                      <strong> Edit permissions for {this.state.userBeingEdited.firstName+this.state.userBeingEdited.lastName}</strong>
                    </div>
                    <div className='card-block'>
                        {this.state.userBeingEdited ?
                          <Select
                            label='testing'
                            multi={true}
                            simpleValue={true}
                            options={options}
                            onChange={this.handleSelectChange}
                            value={this.state.value}
                            >
                          </Select>: []}
                    </div>
                  </div>
                  </div>
                </div>: ''}
            </ModalBody>
          </Modal>
          <Modal isOpen={this.state.verifyModal} toggle={this.toggle} >
            <ModalHeader toggle={this.toggle}>Verify</ModalHeader>
            <Form>
            <ModalBody className="verify-content">
                <Table className="table-responsive table-sm">
                  <thead className='bt-0'>
                    <tr>
                      <th>Requested For</th>
                      <th>Requested By</th>
                      <th>Select</th>
                    </tr>
                  </thead>
                  <tbody>
                    {buildModalBody}
                  </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.verifyEmail}>Verify</Button>{' '}
              <Button color="danger" onClick={this.rejectRequest}>Discard</Button>
              <Button color="secondary" onClick={this.toggle}>Cancel</Button>
            </ModalFooter>
            </Form>
          </Modal>
          <Modal isOpen={this.state.codeBankModal} toggle={this.toggleCodebank} className={this.props.className}>
            <ModalHeader toggle={this.toggleCodebank}>Codebank</ModalHeader>
            <ModalBody className="verify-content">
                <Table className="table-responsive">
                  <thead>
                    <tr>
                      <th>Event Name</th>
                      <th>Expiration Date</th>
                      <th>Password</th>
                    </tr>
                  </thead>
                  <tbody>
                    {buildCodebankModalBody}
                  </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggleCodebank}>Close</Button>
            </ModalFooter>
          </Modal>
          <div className='col-lg-12'>
           
                {this.state.message ? <p className='text-success'> {this.state.message} <i onClick={this.setState({message:null})}className='fa fa-remove'/> </p>: ''}
                {this.state.error ? <p className='text-danger'> {this.state.error} <i className='fa fa-remove' onClick={() => this.setState({error: null})}/> </p>: ''}
                <div className="table-responsive data-view" style={{height: window.innerHeight-200}}>
                <table className='table'>
                  <thead>
                    { tableHeaderNodes }
                    <th> Remove User </th>
                    <th> Edit User </th>
                  </thead>
                  <tbody> {tableRows} </tbody>
                </table>
                </div>
          </div>
        </div>
       </div>
        <Alert stack={{limit: 1}} />
       </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/AdminPanel/AdminPanel.js